// De tokens van de chat (ChatPopup, ChatBlokken, ChatBonnetje, ChatPaneel).
// Zelfde vorm als ../tokens, maar elke kleur, letter en dikte is een
// CSS-variabele met de oude waarde als terugval. In de oude weergave bestaan
// die variabelen niet: daar blijft de chat precies zoals hij live staat. De
// nieuwe weergave zet ze in nieuw/chat.css op de stijllaag, zodat de chat daar
// de nieuwe stijl (licht én donker) volgt zonder dat zijn werking verandert
// (owner 14-10: "alle functionaliteit hetzelfde; paneel eroverheen zoals nu;
// bronnen inline").

import { color as oud, font as oudeLetter, weight as oudeDikte } from "../tokens";

export { chart, metric, radius, size } from "../tokens";

const kleur = <K extends keyof typeof oud>(k: K) => `var(--chat-${k}, ${oud[k]})`;

export const font = `var(--chat-letter, ${oudeLetter})`;

export const color = {
  ink: kleur("ink"),
  body: kleur("body"),
  muted: kleur("muted"),
  soft: kleur("soft"),
  faint: kleur("faint"),
  line: kleur("line"),
  lineSoft: kleur("lineSoft"),
  lineFaint: kleur("lineFaint"),
  border: kleur("border"),
  disabled: kleur("disabled"),
  surface: kleur("surface"),
  surfaceAlt: kleur("surfaceAlt"),
  surfaceHover: kleur("surfaceHover"),
  surfaceQuote: kleur("surfaceQuote"),
  accentAmber: kleur("accentAmber"),
  accentAmberBg: kleur("accentAmberBg"),
  accentBlue: kleur("accentBlue"),
  accentGreen: kleur("accentGreen"),
  accentPurple: kleur("accentPurple"),
  accentRed: kleur("accentRed"),
} as const;

const dikte = <K extends keyof typeof oudeDikte>(k: K) => `var(--chat-dikte-${k}, ${oudeDikte[k]})` as unknown as number;

export const weight = {
  regular: dikte("regular"),
  medium: dikte("medium"),
  bold: dikte("bold"),
  heavy: dikte("heavy"),
} as const;
